




































import Vue from 'vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { Option } from '~/models/shared/types'
import CPostcodeAutocomplete from '~/components/shared/configurable/form/autocomplete/CPostcodeAutocomplete.vue'
export default Vue.extend({
  components: {
    CPostcodeAutocomplete,
    CCustomSelect
  },
  props: {
    countryParentheses: {
      type: Boolean,
      default: false
    },
    id: { type: String, default: null, required: false },
    name: { type: String, default: 'postcode', required: false },
    customClass: { type: String, default: '' },
    defaultCountry: { type: Number, default: 1 },
    value: { type: Object, default: null },
    floatingLabelEnabled: { type: Boolean, default: false, required: false },
    postcodeInputState: {
      type: [Boolean, String, Object, null],
      default: null
    },
    noPortal: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('postcode')
      }
    },
    countries: {
      type: Array,
      default() {
        return [
          {
            code: 'gr',
            name: 'Ελλάδα',
            parent: null,
            has_postcodes: true,
            postcode_validator: '^\\d{5}$',
            telephone_validator: '^(800|801|2[0-9]{2}|69[0-9])[0-9]{7}$',
            id: 1,
            telephone_code: 30
          },
          {
            code: 'cy',
            name: 'Κύπρος',
            parent: null,
            has_postcodes: true,
            postcode_validator: '^\\d{4}$',
            telephone_validator: '^[0-9]*$',
            id: 17,
            telephone_code: 357
          }
        ]
      }
    }
  },
  data() {
    return {
      country: this.value?.country?.id ? this.value.country.id : 1,
      postcode: this.value?.postcode?.name
        ? { name: this.value.postcode.name }
        : null
    }
  },
  computed: {
    isValid() {
      let validator = false
      if (this.country && this.postcode) {
        const regex = this.getValidator(this.postcode)
        validator = this.postcode.name.match(regex)
      } else {
        validator = true
      }
      this.$emit('validation', validator)
      return validator
    },
    realValue() {
      if (!this.postcode || this.postcode?.name.length === 0) {
        return null
      } else {
        return {
          country: { id: parseInt(this.country) || this.defaultCountry },
          postcode: this.postcode || null
        }
      }
    },
    countryOptions(): Option[] {
      return this.countries.map(country => {
        return {
          text: `${this.formatCode(country.code)} - ${country.name}`,
          headerText: `${this.formatCode(country.code)}`,
          value: country.id,
          key: `${country.id}-${country.name}`
        }
      })
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value) {
          try {
            value = JSON.parse(value)
          } catch (e) {}
        }

        value = value || null

        if (value && value.postcode?.name) {
          this.postode = value.postcode.name
        } else {
          this.postcode = null
        }

        if (value && value.country?.id) {
          this.country = value.country.id
        } else {
          this.postcode = null
          this.country = this.defaultCountry
        }
      }
    },
    realValue(value) {
      this.$emit('input', value)
      this.$emit('change')
    }
  },
  methods: {
    getValidator(code) {
      let validator = false
      this.countries.forEach(country => {
        if (country.id === country) {
          validator =
            country.postcode_validator || country.postcodeValidator || null
        }
      })
      if (validator === false && code !== 1) {
        return this.getValidator(1)
      } else if (validator !== false) {
        return validator
      }
      return null
    },
    formatCode(code) {
      if (this.countryParentheses) {
        return `(+${code.toUpperCase()})`
      }
      return `${code.toUpperCase()}`
    },
    handlePostcodeChange({
      country_code: postcodeCountryCode,
      name: postcodeName
    }) {
      this.postcode = { name: postcodeName }
      if (postcodeCountryCode) {
        const foundCountryID = this.countries.find(
          c => c.code === postcodeCountryCode
        )
        this.country = foundCountryID?.id || this.defaultCountry
      }
    }
  }
})
